import { render, staticRenderFns } from "./ExportWizardSave.vue?vue&type=template&id=710ed6d4"
import script from "./ExportWizardSave.vue?vue&type=script&lang=js"
export * from "./ExportWizardSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports